import type {
  AccountSetupDto,
  ForgotPasswordDto,
  LoginDto,
  PublicUser,
  RegisterDto,
  ResetPasswordDto,
} from '@nestjs-boilerplate/types';

import { apiClient } from '@/lib/api-client';

export interface AuthResponse {
  user: PublicUser;
  accessToken: string;
}

export async function login(data: LoginDto): Promise<AuthResponse> {
  return apiClient.fetch<AuthResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function register(data: RegisterDto): Promise<AuthResponse> {
  return apiClient.fetch<AuthResponse>('/auth/register', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function logout(): Promise<{ message: string }> {
  return apiClient.fetch<{ message: string }>('/auth/logout', {
    method: 'POST',
  });
}

export async function refreshToken(): Promise<{ accessToken: string }> {
  return apiClient.fetch<{ accessToken: string }>('/auth/refresh', {
    method: 'POST',
  });
}

export interface AccountSetupResponse {
  user: PublicUser;
}

export async function accountSetup(data: AccountSetupDto): Promise<AccountSetupResponse> {
  return apiClient.fetch<AccountSetupResponse>('/auth/account-setup', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export interface MessageResponse {
  message: string;
}

export async function forgotPassword(data: ForgotPasswordDto): Promise<MessageResponse> {
  return apiClient.fetch<MessageResponse>('/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function resetPassword(data: ResetPasswordDto): Promise<MessageResponse> {
  return apiClient.fetch<MessageResponse>('/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export interface MeResponse {
  user: PublicUser;
}

export async function getMe(): Promise<MeResponse> {
  return apiClient.fetch<MeResponse>('/auth/me', {
    method: 'GET',
  });
}

export interface VerifyEmailResponse {
  message: string;
  user: PublicUser;
}

export async function verifyEmail(token: string): Promise<VerifyEmailResponse> {
  return apiClient.fetch<VerifyEmailResponse>('/auth/verify-email', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });
}

export async function resendVerificationEmail(): Promise<MessageResponse> {
  return apiClient.fetch<MessageResponse>('/auth/resend-verification-email', {
    method: 'POST',
  });
}
